import classNames from 'classnames';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import RichText from 'molecules/RichText';

import styles from 'components/Testimonial/testimonial.module.scss';

import type { TestimonialProps } from 'components/Testimonial/config';
import type { FC } from 'react';

const Testimonial: FC<TestimonialProps> = ({
  backgroundColor = 'white',
  titleImage,
  content,
  Cta,
  disclaimer,
  image,
  align,
}) => {
  const isLight = ['blue', 'white', 'gray', 'lightgray', 'wgray80'].includes(backgroundColor);
  const isArrowButton = Cta?.type === 'arrow';
  const wrapperClass = classNames(isLight ? styles.light : styles.dark, {
    [styles.bkgBlue]: backgroundColor === 'blue',
    [styles.bkgGray]: backgroundColor === 'gray',
    [styles.bkgTeal]: backgroundColor === 'teal',
    [styles.bkgWhite]: backgroundColor === 'white',
    [styles.bkLightGray]: backgroundColor === 'lightgray',
    [styles.bkAsh]: backgroundColor === 'ash',
    [styles.bkDarkAsh]: backgroundColor === 'darkash',
    [styles.bkCarbon]: backgroundColor === 'carbon',
    [styles.bkWGray80]: backgroundColor === 'wgray80',
    [styles.bkGreige]: backgroundColor === 'greige',
  });

  return (
    <div className={`${align !== 'split' && wrapperClass}`}>
      <div
        className={`${styles.container} ${align === 'left' && styles.standard}  ${
          align === 'right' && styles.reverse
        } ${align === 'split' && styles.split}`}
      >
        <div className={`${styles.left} ${align === 'split' && wrapperClass}`}>
          <div className={styles.content}>
            {titleImage?.url && (
              <Image
                url={titleImage?.url}
                alt={titleImage?.alt}
                height={titleImage?.height || 1000}
                width={titleImage?.width || 2000}
                className={styles.img}
              />
            )}
            {content && (
              <RichText
                content={content
                  .replace(/\\n/g, '\n')
                  .replace(/\\h5/g, '<h5>')
                  .replace(/\\ch5/g, '</h5>')
                  .replace(/\\b/g, '<div>')
                  .replace(/\\cb/g, '</div>')}
                light={!isLight}
                className={styles.richText}
              />
            )}
            {Cta?.label &&
              (isArrowButton ? (
                <div className={isLight ? styles.lightArrow : styles.darkArrow}>
                  <a href={Cta.href}>{Cta.label}</a>
                </div>
              ) : (
                <Button url={Cta.href} color={isLight ? 'gray' : 'teal'} label={Cta?.label} className={styles.button} />
              ))}
            {disclaimer && (
              <p className={styles.disclaimer}>
                <span>{disclaimer}</span>
              </p>
            )}
            {align === 'left' && !isLight && !disclaimer && <p className={styles.addMargin}>&nbsp;</p>}
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.image}>
            <Image
              url={image?.url}
              alt={image?.alt}
              height={image?.height || 1000}
              width={image?.width || 2000}
              className={styles.image}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
